import { useState } from "react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { FileDown, Loader2 } from "lucide-react";
import { useI18n } from "../lib/i18n";
import { downloadModulePdf } from "../lib/psychoeducationExport";

export const ModulePdfButton = ({ moduleId, patientName = "", variant = "outline", size = "sm", className = "", iconOnly = false }) => {
  const { t, locale } = useI18n();
  const [busy, setBusy] = useState(false);
  const run = async (e) => {
    e.stopPropagation();
    setBusy(true);
    try { await downloadModulePdf(moduleId, locale, patientName); }
    catch (err) { toast.error(err.response?.data?.detail || t("psychoeducation.pdfError", "PDF indisponible")); }
    finally { setBusy(false); }
  };
  return (
    <Button variant={variant} size={size} onClick={run} disabled={busy} className={`gap-1.5 ${className}`} title={t("psychoeducation.downloadPdfHint", "Télécharger ce module en PDF (chapitres, illustrations, quiz et corrigé)")} data-testid={`module-pdf-${moduleId}`}>
      {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <FileDown className="w-3.5 h-3.5" />}
      {!iconOnly && (busy ? t("patientExercises.generating") : t("psychoeducation.downloadPdf", "Télécharger en PDF"))}
    </Button>
  );
};
